
import { defineComponent } from "vue";
import { VNavigationDrawer } from "vuetify/lib";

export default defineComponent({
  mixins: [VNavigationDrawer],
  props: {
    overlayOpacity: {
      type: [Number, String],
      default: "0.32",
    },
  },
});
